import { render, staticRenderFns } from "./SourcingBoardView.vue?vue&type=template&id=645e940a&scoped=true"
import script from "./SourcingBoardView.vue?vue&type=script&lang=js"
export * from "./SourcingBoardView.vue?vue&type=script&lang=js"
import style0 from "./SourcingBoardView.vue?vue&type=style&index=0&id=645e940a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645e940a",
  null
  
)

export default component.exports